import { render, staticRenderFns } from "./ratingCategorySet.vue?vue&type=template&id=b6d41f18&scoped=true"
import script from "./ratingCategorySet.vue?vue&type=script&lang=js"
export * from "./ratingCategorySet.vue?vue&type=script&lang=js"
import style0 from "./ratingCategorySet.vue?vue&type=style&index=0&id=b6d41f18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d41f18",
  null
  
)

export default component.exports